import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import plYaml from 'js-yaml-loader!../../../translations/messages+intl-icu.pl.yml';
import enYaml from 'js-yaml-loader!../../../translations//messages+intl-icu.en.yml';
const splitPlurals = (object) => {
    const newObject = {};
    Object.keys(object).forEach((key) => {
      let elem = object[key]; 
      if (typeof elem === 'object') {
        newObject[key] = splitPlurals(elem);
        return;
      }
      // replace all symfony parameters %param% with {{param}} in all strings for js
      elem = String(elem).replace(/%([^%]+(?=%))%/gi, '{{$1}}');
  
      // splits all plurales like "one apple|many apples" into different keys apple and apple_plural
      if (typeof elem === 'string' && elem.includes('|')) {
        const plural = elem.split('|');
        newObject[key] = plural.shift();
        newObject[`${key}_plural`] = plural.shift();
  
        return;
      }
  
      newObject[key] = elem;
    });
  
    return newObject;
  };
  
  i18n
    .use(initReactI18next)
    .init({
      resources: {
        pl: {
          translation: splitPlurals(plYaml),
        },
        en: {
          translation: splitPlurals(enYaml),
        },
      },
      lng: (window && window.locale) || 'pl',
      fallbackLng: 'pl',
      // keySeparator: false, // don't count "." as separator
    });
  
  export default i18n;